import React, { Component } from 'react';
import '../reports.css'
import '../../../../../node_modules/react-datetime/css/react-datetime.css'
import NotificationSystem from 'react-notification-system';
import TmExportExcel from '../../../Misc/tmExportExcel/tmExportExcel';
import ReactTable from 'react-table'
// import 'react-table/react-table.css'
// import '../src/assets/css/react-table.css'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { get } from '../../../../server/actions'
import { getActiveSchoolYearSettings } from '../../ManageSchools/manageSchoolSettings';
import Datetime from 'react-datetime'
import { MONTH } from '../../../../server/constants'
import {
    _addNotification, _addNotificationError, formatDate, showFile,
    getModuleEnum, getAccessLevelByModule, gradeNoToText
} from "../../../../server/util";
// Demo styles, see 'Styles' section below for some notes on use.
import { getGradeNumberByText, getSchoolGrades, groupBy } from '../../../../server/util'

import 'react-accessible-accordion/dist/fancy-example.css';
import '../../../../../src/assets/css/react-table.css'

import { BeatLoader } from 'react-spinners';
//import PrintLabels from './printLabels';
import moment from 'moment'
import AuditReport from '../auditReportComponents/auditReport'
import TempEligibilityReport from './tempEligibilityReport';
import FRLReport from './frlReport';
import BenefitsIssuanceListReport from './benefitsIssuanceReport';
import AdverseActionReport from './adverseActionReport';
import CepAuditReport from '../auditReportComponents/cepAuditReport';
let download = require('downloadjs');
require('moment')
let catererHeader = ''
var converter = require('number-to-words');
var valid = function (current) {
    let maxDate = moment().add(2, 'months');
    if (current <= maxDate) {
        return current.day() !== 0 && current.day() !== 6;
    }
    else {
        return false;
    }

};
const modalStyles = {
    content: {
        top: '30%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '30%',
        transform: 'translate(-50%, -50%)',
        overflow: 'initial'
    }
};
const tickstyles = {
    width: '20px',
    height: '20px',
    lineHeight: '20px',
    textAlign: 'center',
    borderRadius: '20%',
    color: '#ffffff',
    fontSize: '14px',
}
const enumMealType = {
    lunch: 'Lunch',
    breakfast: 'Breakfast',
    milk: 'Milk',
    snack: 'Snack'
}
function removeActiveclassName(node) {
    let siblings = node.parentNode.childNodes
    console.log(siblings)
    siblings.forEach(node => {
        node.classList.remove("active");
    })
    node.classList.add('active');
}

const modEnum = getModuleEnum();
class ClaimReport extends Component {
    constructor() {
        super()
        this.state = {
            loading: false,
            range: null,
            type: null,
            grade: null,
            report: null,
            catererData: [],
            mealTypes: enumMealType.lunch,
            catererColumns: [],
            schoolReports: [],
            date: '',
            allReportsDate: '',
            modalIsOpen: false,
            firstDay: formatDate(new Date()),
            lastDay: formatDate(new Date()),
            selectedReportType: 5,
            checkReportDate: moment(),
            eligTypes: [],
            lunchEligibilityReportResponse: [],
            schoolYearSettings: {},
        }
        this.renderInput = this.renderInput.bind(this);
        this.exportSchoolReport = this.exportSchoolReport.bind(this);
        this.exportCatererReport = this.exportCatererReport.bind(this);
        this.exportAllergyReport = this.exportAllergyReport.bind(this);
        this.exportFreeReducedLunchReport = this.exportFreeReducedLunchReport.bind(this);
        this.notOrderedLunchReport = this.notOrderedLunchReport.bind(this);
        this.quickReports = this.quickReports.bind(this);
        this.generateCustomReports = this.generateCustomReports.bind(this);
        this.downloadReport = this.downloadReport.bind(this);
        this.exportFreeReducedLunchActualReport = this.exportFreeReducedLunchActualReport.bind(this)
    }

    componentWillMount() {
        this.getSchoolYearSettings();
    }

    renderInput = (props, openCalendar, closeCalendar) => {
        return (
            <div>
                <input {...props} />
                <button type="button" className="input-group-addon" onClick={openCalendar}>
                    <i className="fa fa-calendar"> </i>
                </button>
            </div>
        );
    }
    setCheckReportDate = (e) => {
        //alert(e)
        this.refs.calendar.closeCalendar()
        this.setState({ checkReportDate: e })
    }
    setRange = (e) => {
        this.setState({ range: e.target.id, report: false })
        document.getElementById("calendar").style.display = ''
        let element = document.getElementById(e.target.id)
        removeActiveclassName(element)

    }
    setAllReportsDate = (e) => {
        //alert(e)
        this.refs.calendar1.closeCalendar()
        this.setState({ allReportsDate: e })
    }
    setDate = (e) => {
        //alert(e)
        document.getElementById("grades").style.display = ''
        this.refs.calendar.closeCalendar()
        this.setState({ date: e, report: false })
    }
    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
        if (!getAccessLevelByModule(modEnum.CEPS)) {
            this.getLunchEligibilityReports()

        }
    }

     getSchoolYearSettings = () => {
        getActiveSchoolYearSettings(sessionStorage.getItem('SchoolId'))
            .then((schoolYearSettings) => {
                this.setState({ schoolYearSettings });
            }).catch(
                (error) => {
                    console.log('Get manage school response', error)
                }
            );
        }

    setGrade = (e) => {
        this.setState({ grade: e.target.id, report: false })
        let element = document.getElementById(e.target.id)
        removeActiveclassName(element)
    }
    downloadReport = () => {
        let isSchoolrequired = false;
        let _refNotify = this.props.refNotify;
        let _self = this;
        let schoolID = parseInt(sessionStorage.getItem('SchoolId'))

        let schoolYear = parseInt(sessionStorage.getItem('schoolYearValue'))
        let userInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));

        //this.setState({loading: true})
        // var start = moment(this.state.startDate).format('YYYY-MM-DD')+"T00:00:00";
        // var end = moment(this.state.endDate).format('YYYY-MM-DD')+"T23:59:59";  
        var districtID = userInfo.districtId || 0
        if (this.state.selectedReportType == 4 || this.state.selectedReportType == 5) {
            var date = new Date(this.state.checkReportDate);
            var firstDay = formatDate(new Date(date.getFullYear(), date.getMonth(), 1));
            var lastDay = formatDate(new Date(date.getFullYear(), date.getMonth() + 1, 0));
            //var yearMonth = date.getFullYear()+""+(date.getMonth()+1)
        }
        if (this.state.selectedReportType !== 0) {
            // let _url=""
            let reportType = parseInt(this.state.selectedReportType)
            const start = moment(this.state.checkReportDate.startOf('month')).format('YYYY-MM-DDT00:00:00');
            const end = moment(this.state.checkReportDate.endOf("month")).format('YYYY-MM-DDT23:59:59');
            const yearMonth = this.state.checkReportDate.format('YYYYMM')
            //         _url='/reports/auditDailyEditCheck?districtId='+districtID+'&mealSchoolId=' + schoolID 
            //         + '&startDate=' + moment(firstDay,'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") + '&endDate=' + moment(lastDay,'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") + '&itemType=' + (this.state.mealType) +
            //          '&schoolYear='+schoolYear+'&yearMonth='+yearMonth+'&access_token='
            // const start = moment(this.state.startDate).format('YYYY-MM-DDT00:00:00');
            // const end = moment(this.state.endDate).format('YYYY-MM-DDT23:59:59');     
            let _url = '/reports/auditDailyEditCheck?mealSchoolId=' + sessionStorage.getItem('SchoolId')
                + '&startDate=' + moment(start, 'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") + '&endDate=' + moment(end, 'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") + '&itemType=' + (this.state.mealTypes) +
                '&yearMonth=' + yearMonth + '&schoolYear=' + sessionStorage.getItem('schoolYearValue') + '&access_token='


            if (isSchoolrequired) {

                _addNotificationError("Please select school", _self)
                return
            }
            console.log("jjjjjj")

            this.setState({ loading: true })

            get(_url)
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 417 || response.status === 422) {
                            return response.json();
                        }
                        //throw Error(response.errorMessage);
                    }
                    console.log('response', response);
                    return response;
                }).then(res => {
                    if (res.statusCode === 417) {
                        //_addNotificationError(res.errorMessage,this)
                        throw Error(res.errorMessage);
                    } else if (res.statusCode === 422) {
                        throw Error(res.statusMessage);
                    } else {
                        return res.blob();
                    }
                }).then(blob => {
                    let filename = "DailyEditCheckReport";
                    showFile(blob, filename);
                    this.setState({ loading: false })
                }).catch(
                    (error) => {
                        let msg = ''
                        if (typeof error === 'string') {
                            msg = error;
                        } else {
                            msg = error.message;
                        }
                        _addNotificationError(msg, _self)
                        //console.log('Get Excel File response', error)
                        this.setState({ loading: false })
                    }
                )
            return
        }

    }
    setType = (e) => {
        this.setState({ type: e.target.id })
        document.getElementById("range").style.display = ''
        document.getElementById("grades").style.display = 'none'
        document.getElementById("calendar").style.display = 'none'
        this.setState({
            range: null, grade: null, date: null, report: false
        })
        let element = document.getElementById(e.target.id)
        removeActiveclassName(element)
        let gradeNode = document.getElementById("selectGrades");
        let childGrades = gradeNode.childNodes
        childGrades.forEach(node => {
            node.classList.remove("active");
        })
    }
    generateReports = (e) => {
        let _self = this;
        this.setState({ loading: true })
        e.preventDefault()
        let firstDay = ''
        let lastDay = ''
        let date = new Date(this.state.allReportsDate);
        firstDay = formatDate(new Date(date.getFullYear(), date.getMonth(), 1));
        lastDay = formatDate(new Date(date.getFullYear(), date.getMonth() + 1, 0));
        get('/reports/exportReports?isVersion2=true&mealSchoolId=' + sessionStorage.getItem('SchoolId') + '&startDate=' + firstDay + '&endDate=' + lastDay + '&fileType=Pdf&loggedUser=' + sessionStorage.getItem('loggedUserName') + '&schoolYear=' + sessionStorage.getItem('schoolYearValue') + '&access_token=').then((response) => {
            if (!response.ok) {
                if (response.status === 417) {
                    return response.json();
                }
            }
            console.log('response', response);
            return response;
        }).then(res => {
            if (res.statusCode === 417) {
                // _addNotificationError(res.statusMessage,this)
                throw Error(res.statusMessage);
            } else if (!res.statusCode === 200) {
                throw Error(res.errorMessage);
            } else {
                return res.json();
            }
        }).then(res => {
            document.getElementsByName('completeReport')[0].disabled = true;
            _addNotification('Request has been submitted successfully. You will receive an email soon.', this)
            this.setState({ loading: false, modalIsOpen: false })
        }).catch(
            (error) => {
                let msg = ''
                if (typeof error === 'string') {
                    msg = error;
                } else {
                    msg = error.message;
                }
                _addNotificationError(msg, _self)
                this.setState({ loading: false })
                //console.log('Get Excel File response', error)
            }
        )
    }
    generateCustomReports = () => {
        let _self = this;
        let grade = ''
        let date = ''
        let firstDay = ''
        let lastDay = ''

        if (_self.state.grade == 0) {
            grade = _self.state.grade;
        } else {
            grade = gradeNoToText(_self.state.grade);
        }
        if (_self.state.range === "daily") {
            firstDay = formatDate(new Date(_self.state.date))
            lastDay = firstDay
        } else if (_self.state.range === "monthly") {
            date = new Date(_self.state.date);
            firstDay = formatDate(new Date(date.getFullYear(), date.getMonth(), 1));
            lastDay = formatDate(new Date(date.getFullYear(), date.getMonth() + 1, 0));
        } else if (_self.state.range === "weekly") {
            date = new Date(_self.state.date);
            //commented by sudhakar

            // var first = date.getDate() - date.getDay(); // First day is the day of the month - the day of the week
            //  var last = first + 6; // last day is the first day + 6
            // firstDay = new Date(date.setDate(first)).toUTCString();
            // lastDay = new Date(date.setDate(last)).toUTCString();
            // firstDay = formatDate(new Date(firstDay));
            // lastDay = formatDate(new Date(lastDay));
            //var curr = new Date;

            firstDay = formatDate(new Date(new Date(date.setDate(date.getDate() - date.getDay())).toUTCString()));
            lastDay = formatDate(new Date(new Date(date.setDate(date.getDate() - date.getDay() + 6)).toUTCString()));
        }
        _self.setState({ loading: true })
        if (_self.state.type === "school") {

            get('/reports/schoolMealReport?isVersion2=true&mealSchoolId=' + sessionStorage.getItem('SchoolId') + '&startDate=' + firstDay + '&endDate=' + lastDay + '&grades=' + grade + '&schoolYear=' + sessionStorage.getItem('schoolYearValue') + '&access_token=').then((response) => {
                if (!response.statusCode === 200) {
                    throw Error(response.errorMessage);
                }
                console.log('response', response);
                return response.json();
            }).then(res => {
                if ((res.studentWithMeal || []).length === 0) {
                    _self.setState({ schoolReports: [], report: true, loading: false });
                } else if (Object.keys(res.mealsByGradeAndDate).length === 0) {
                    _self.setState({ schoolReports: [], report: true, loading: false });
                }
                else {
                    let columns = [];
                    Object.keys(res.mealsByGradeAndDate[Object.keys(res.mealsByGradeAndDate)[0]]).forEach((Date, idx) => {
                        let data = []
                        let col = [{
                            Header: 'Grade: ' + this.state.grade,
                            accessor: 'grade',
                            columns: [
                                {
                                    Header: "Name",
                                    accessor: "name"
                                },
                                {
                                    Header: "Teacher",
                                    accessor: "teacherName"
                                },
                                {
                                    Header: "Allergies",
                                    accessor: "allergies",
                                    show: getAccessLevelByModule(modEnum.MKA) ? true : false
                                }
                            ]
                        },
                        {
                            Header: "Date:" + Date,
                            accessor: "dateValue",
                            columns: res.mealsByGradeAndDate[Object.keys(res.mealsByGradeAndDate)[0]][Date].map(meal => {
                                return {
                                    Header: meal,
                                    accessor: meal.replace(/ +/g, ""),
                                    style: { textAlign: 'center' },
                                    Cell: (rowInfo, row) => {
                                        return ((rowInfo.row[meal.replace(/ +/g, "")] != undefined) ? <i className="fa fa-check bg-color-2" style={tickstyles} aria-hidden="true"></i> : null);
                                    }
                                }

                            })

                        }
                        ];
                        res.studentWithMeal.forEach((student, idx) => {
                            let studentDetails = {}
                            studentDetails.no = idx + 1;
                            studentDetails.name = student.studentLName + ', ' + student.studentFName;
                            studentDetails.teacherName = student.teacherName;
                            studentDetails.allergies = student.allergies
                            if (student.mealOrderedByDate !== null) {
                                // / alert(JSON.stringify(student.mealOrderedByDate, null, 2))
                                Object.keys(student.mealOrderedByDate).forEach(function (key, idx) {
                                    if (key === Date) {
                                        student.mealOrderedByDate[key].forEach(item => {
                                            studentDetails[item.replace(/ +/g, "")] = ''
                                        })

                                    }
                                })
                            } else {
                            }
                            data.push(studentDetails)
                        })
                        columns[idx] = [col, data]
                    })
                    console.log("cOLUMSN" + JSON.stringify(columns, null, 2))

                    _self.setState({ report: true, schoolReports: columns, loading: false })
                    //   console.log(data)

                }
            }).catch(
                (error) => {
                    _addNotificationError(error, _self)
                    _self.setState({ loading: false })
                    console.log('Get Order History response', error)
                }
            )

        } else {

            (grade == 0 ? (get('/reports/catererReport?isVersion2=true&mealSchoolId=' + sessionStorage.getItem('SchoolId') + '&startDate=' + firstDay + '&endDate=' + lastDay + '&access_token=')) : (get('/reports/catererReport?isVersion2=true&mealSchoolId=' + sessionStorage.getItem('SchoolId') + '&startDate=' + firstDay + '&endDate=' + lastDay + '&grades=' + grade + '&access_token='))).then((response) => {
                if (!response.statusCode === 200) {
                    throw Error(response.errorMessage);
                }
                console.log('response', response);
                return response.json();
            }).then(res => {
                let data = []
                Object.keys(res.dateMealItemCountMap).map(x => {
                    let listItem = res.dateMealItemCountMap[x];
                    let dataList = [];
                    dataList = Object.keys(listItem).map((i, key) => {

                        return { no: key + 1, item: i, count: listItem[i] + '' }
                    });
                    let head = <div>
                        <h5>School:&nbsp;{res.schoolName}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{grade == 0 ? 'All Grades' : 'Grade: ' + this.state.grade}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            {_self.state.range === "daily" ? "Date : " + res.startDate : (_self.state.range === "weekly" ? "Week : " + res.startDate + ' - ' + res.endDate : 'Month : ' + MONTH[new Date(res.startDate.split("-")[0], res.startDate.split("-")[1] - 1, res.startDate.split("-")[2]).getMonth()] + ' ' + new Date(res.startDate).getFullYear())}</h5>
                        <div>Date: {x}</div>
                    </div>
                    data.push({ recDate: x, recdata: dataList, header: head });
                });

                _self.setState({ report: true, catererData: data, loading: false })
            }).catch(
                (error) => {
                    _addNotificationError(error, _self)
                    _self.setState({ loading: false })
                    console.log('Get Order History response', error)
                }
            )
        }

    }
    renderInput = (props, openCalendar, closeCalendar) => {
        function clear() {
            props.onChange({ target: { value: '' } });
        }

        return (
            <div>
                <input {...props} />
                <button type="button" className="input-group-addon" onClick={openCalendar}>
                    <i className="fa fa-calendar"></i>
                </button>
            </div>
        );
    }
    markSelected = (state, rowInfo, column) => {

    }
    quickReports = (fileType, day, gradeValue) => {
        let _self = this;
        let grade = ''
        let firstDay = ''
        let lastDay = ''
        let d1 = ''
        if (day === 'currentDay') {
            firstDay = formatDate(new Date())
            lastDay = firstDay
        }
        else if (day === 'nextDay') {

            d1 = new Date();
            var first = d1.getDate() + 1;
            var last = first;
            firstDay = new Date(d1.setDate(first)).toUTCString();
            lastDay = firstDay;
            firstDay = formatDate(new Date(firstDay));
            lastDay = formatDate(new Date(lastDay));
        }
        else if (day === 'dayAfter') {
            d1 = new Date();
            var first = d1.getDate() + 2;
            var last = first;
            firstDay = new Date(d1.setDate(first)).toUTCString();
            lastDay = firstDay
            firstDay = formatDate(new Date(firstDay));
            lastDay = formatDate(new Date(lastDay));
        }
        if (gradeValue === undefined) {
            grade = 0;
        } else {
            grade = gradeNoToText(gradeValue);
        }
        (grade === 0 ? (get('/reports/schoolExportReport?isVersion2=true&mealSchoolId=' + sessionStorage.getItem('SchoolId') + '&startDate=' + firstDay + '&endDate=' + lastDay + '&fileType=' + fileType + '&schoolYear=' + sessionStorage.getItem('schoolYearValue') + '&access_token='))
            :
            (get('/reports/schoolExportReport?isVersion2=true&mealSchoolId=' + sessionStorage.getItem('SchoolId') + '&startDate=' + firstDay + '&endDate=' + lastDay + '&grades=' + grade + '&fileType=' + fileType + '&schoolYear=' + sessionStorage.getItem('schoolYearValue') + '&access_token='))).then((response) => {

                if (!response.ok) {
                    if (response.status === 417) {
                        return response.json();
                    }
                }
                console.log('response', response);
                return response;
            }).then(res => {
                if (res.statusCode === 417) {
                    // _addNotificationError(res.statusMessage,this)
                    throw Error(res.statusMessage);
                } else if (!res.statusCode === 200) {
                    throw Error(res.errorMessage);
                } else {
                    return res.blob();
                }
            }).then(blob => {
                let filename = "School Reports for " + (grade === 0 ? 'all grades' : 'grade-' + grade);

                if (fileType === "Pdf") {
                    // download(blob,filename + '.pdf', "pdf");
                    showFile(blob, filename);
                }
                else {
                    download(blob,
                        filename + '.xls', "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
                }

            }).catch(
                (error) => {
                    let msg = ''
                    if (typeof error === 'string') {
                        msg = error;
                    } else {
                        msg = error.message;
                    }
                    _addNotificationError(msg, _self)
                    this.setState({ loading: false })
                    //console.log('Get Excel File response', error)
                }
            )

    }

    exportSchoolReport(fileType, range, date, grades) {
        let _self = this;
        let grade = ''
        let firstDay = ''
        let lastDay = ''
        let d1 = ''
        let d2 = ''
        if (range.toLowerCase() === "daily") {
            firstDay = formatDate(new Date(date))
            lastDay = firstDay
        }

        else if (range.toLowerCase() === "monthly") {
            d1 = new Date(date);
            firstDay = formatDate(new Date(d1.getFullYear(), d1.getMonth(), 1));
            lastDay = formatDate(new Date(d1.getFullYear(), d1.getMonth() + 1, 0));
        } else if (range.toLowerCase() === "weekly") {
            d1 = new Date(date);
            d2 = new Date(date);
            var first = d1.getDate() - d1.getDay();// First day is the day of the month - the day of the week
            var last = first + 6; // last day is the first day + 6
            console.log('first', first);
            console.log('last', last);
            firstDay = new Date(d1.setDate(first)).toUTCString();
            lastDay = new Date(d2.setDate(last)).toUTCString();
            console.log('firstDay', firstDay);
            console.log('lastDay', lastDay);
            firstDay = formatDate(new Date(firstDay));
            lastDay = formatDate(new Date(lastDay));
        }
        else if (range === "nextWeek") {
            d1 = new Date(date);
            d2 = new Date(date);
            var first = d1.getDate() - d1.getDay() + 7; // First day is the day of the month - the day of the week
            var last = first + 6; // last day is the first day + 6
            console.log('first', first);
            console.log('last', last);
            firstDay = new Date(d1.setDate(first)).toUTCString();
            lastDay = new Date(d2.setDate(last)).toUTCString();
            console.log('firstDay', firstDay);
            console.log('lastDay', lastDay);
            firstDay = formatDate(new Date(firstDay));
            lastDay = formatDate(new Date(lastDay));
        }
        else if (range === "weekAfter") {
            let d1 = new Date(date);
            let d2 = new Date(date);
            var first = d1.getDate() - d1.getDay() + 14; // First day is the day of the month - the day of the week
            var last = first + 6; // last day is the first day + 6
            console.log('first', first);
            console.log('last', last);
            firstDay = new Date(d1.setDate(first)).toUTCString();
            lastDay = new Date(d2.setDate(last)).toUTCString();
            console.log('firstDay', firstDay);
            console.log('lastDay', lastDay);
            firstDay = formatDate(new Date(firstDay));
            lastDay = formatDate(new Date(lastDay));
        }
        if (grades == 0) {
            grade = grades;
        } else {
            grade = gradeNoToText(grades);
        }
        (grade == 0 ? (get('/reports/schoolExportReport?isVersion2=true&mealSchoolId=' + sessionStorage.getItem('SchoolId') + '&startDate=' + firstDay + '&endDate=' + lastDay + '&fileType=' + fileType + '&schoolYear=' + sessionStorage.getItem('schoolYearValue') + '&access_token=')) : (get('/reports/schoolExportReport?isVersion2=true&mealSchoolId=' + sessionStorage.getItem('SchoolId') + '&startDate=' + firstDay + '&endDate=' + lastDay + '&grades=' + grade + '&fileType=' + fileType + '&schoolYear=' + sessionStorage.getItem('schoolYearValue') + '&access_token='))).then((response) => {
            if (!response.ok) {
                if (response.status === 417) {
                    return response.json();
                }
            }
            console.log('response', response);
            return response;
        }).then(res => {
            if (res.statusCode === 417) {
                // _addNotificationError(res.statusMessage,this)
                throw Error(res.statusMessage);
            } else if (!res.statusCode === 200) {
                throw Error(res.errorMessage);
            } else {
                return res.blob();
            }
        }).then(blob => {
            let filename = 'School' + ' ' + range + ' ' + (grades == 0 ? 'all grades' : 'grade-' + grades) + ' ' + 'reports';
            if (fileType === "Pdf") {
                //download(blob,filename + '.pdf', "pdf");
                showFile(blob, filename);
            }
            else {
                download(blob,
                    filename + '.xls', "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
            }

        }).catch(
            (error) => {
                let msg = ''
                if (typeof error === 'string') {
                    msg = error;
                } else {
                    msg = error.message;
                }
                _addNotificationError(msg, _self)
                this.setState({ loading: false })
                //console.log('Get Excel File response', error)
            }
        )
    }

    exportAllergyReport(fileType) {
        let _self = this
        get('/reports/allergiesReport?mealSchoolId=' + sessionStorage.getItem('SchoolId') + '&schoolYear=' + sessionStorage.getItem('schoolYearValue') + '&fileType=' + fileType + '&access_token=').then((response) => {
            if (!response.ok) {
                if (response.status === 417) {
                    return response.json();
                }
            }
            console.log('response', response);
            return response;
        }).then(res => {
            if (res.statusCode === 417) {
                // _addNotificationError(res.statusMessage,this)
                throw Error(res.statusMessage);
            } else if (!res.statusCode === 200) {
                throw Error(res.errorMessage);
            } else {
                return res.blob();
            }
        }).then(blob => {
            let filename = 'Allergy Report for all grades';

            if (fileType === "Pdf") {
                //download(blob,filename + '.pdf', "pdf");
                showFile(blob, filename);
            }
            else {
                download(blob,
                    filename + '.xls', "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
            }

        }).catch(
            (error) => {
                let msg = ''
                if (typeof error === 'string') {
                    msg = error;
                } else {
                    msg = error.message;
                }
                _addNotificationError(msg, _self)
                this.setState({ loading: false })
                //console.log('Get Excel File response', error)
            }
        )

    }
    exportFreeReducedLunchReport(fileType) {
        let _self = this;
        get('/reports/fmSurveyReport?mealSchoolId=' + sessionStorage.getItem('SchoolId') + '&fileType=' + fileType + '&access_token=').then((response) => {
            if (!response.ok) {
                if (response.status === 417) {
                    return response.json();
                }
            }
            console.log('response', response);
            return response;
        }).then(res => {
            if (res.statusCode === 417) {
                // _addNotificationError(res.statusMessage,this)
                throw Error(res.statusMessage);
            } else if (!res.statusCode === 200) {
                throw Error(res.errorMessage);
            } else {
                return res.blob();
            }
        }).then(blob => {
            let filename = 'Free reduced lunch report';

            if (fileType === "Pdf") {
                //download(blob,filename + '.pdf', "pdf");
                showFile(blob, filename);
            }
            else {
                download(blob,
                    filename + '.xls', "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
            }
        }).catch(
            (error) => {
                let msg = ''
                if (typeof error === 'string') {
                    msg = error;
                } else {
                    msg = error.message;
                }
                _addNotificationError(msg, _self)
                this.setState({ loading: false })
                //console.log('Get Excel File response', error)
            }
        );
    }
    exportFreeReducedLunchActualReport(fileType, eligType = undefined) {
        let _self = this;
        let _urlFilter = '/reports/fmActualReport?mealSchoolId=' + sessionStorage.getItem('SchoolId') + '&fileType=' + fileType + '&schoolYear=' + sessionStorage.getItem('schoolYearValue');
        if (eligType === 'Free' || eligType === 'Reduced') {
            _urlFilter += '&eligType=' + eligType;
        }
        _urlFilter += '&access_token=';
        get(_urlFilter).then((response) => {
            if (!response.ok) {
                if (response.status === 417) {
                    return response.json();
                }
            }
            console.log('response', response);
            return response;
        }).then(res => {
            if (res.statusCode === 417) {
                // _addNotificationError(res.statusMessage,this)
                throw Error(res.statusMessage);
            } else if (!res.statusCode === 200) {
                throw Error(res.errorMessage);
            } else {
                return res.blob();
            }
        }).then(blob => {
            let filename = eligType ? eligType + ' lunch actual report' : 'Free reduced lunch actual report';

            if (fileType === "Pdf") {
                //download(blob,filename + '.pdf', "pdf");
                showFile(blob, filename);
            }
            else {
                download(blob,
                    filename + '.xls', "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
            }
        }).catch(
            (error) => {
                let msg = ''
                if (typeof error === 'string') {
                    msg = error;
                } else {
                    msg = error.message;
                }
                _addNotificationError(msg, _self)
                this.setState({ loading: false })
                //console.log('Get Excel File response', error)
            }
        );
    }

    notOrderedLunchReport(fileType, range, date, grades) {
        let _self = this;
        let _yearMonth
        if (range == 'nextMonth') {
            _yearMonth = moment().add(1, 'month').format('YYYYMM');
        }
        else {
            _yearMonth = moment().format('YYYYMM');
        }
        get('/reports/notOrderedLunchReport?isVersion2=true&mealSchoolId=' + sessionStorage.getItem('SchoolId') + '&yearMonth=' + _yearMonth + '&schoolYear=' + sessionStorage.getItem('schoolYearValue') + '&fileType=' + fileType + '&access_token=').then((response) => {
            if (!response.ok) {
                if (response.status === 417) {
                    return response.json();
                }
            }
            console.log('response', response);
            return response;
        }).then(res => {
            if (res.statusCode === 417) {
                // _addNotificationError(res.statusMessage,this)
                throw Error(res.statusMessage);
            } else if (!res.statusCode === 200) {
                throw Error(res.errorMessage);
            } else {
                return res.blob();
            }
        }).then(blob => {
            let filename = 'Not Ordered Students lunch report';

            if (fileType === "Pdf") {
                //download(blob,filename + '.pdf', "pdf");
                showFile(blob, filename);
            }
            else {
                download(blob,
                    filename + '.xls', "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
            }

        }).catch(
            (error) => {
                let msg = ''
                if (typeof error === 'string') {
                    msg = error;
                } else {
                    msg = error.message;
                }
                _addNotificationError(msg, _self)
                this.setState({ loading: false })
                //console.log('Get Excel File response', error)
            }
        );
    }
    exportCatererReport(fileType, range, date, grades) {
        let _self = this;
        let grade = ''
        let firstDay = ''
        let lastDay = ''
        let d1 = ''
        let d2 = ''
        if (range.toLowerCase() === "daily") {
            firstDay = formatDate(new Date(date))
            lastDay = firstDay
        } else if (range.toLowerCase() === "monthly") {

            d1 = new Date(date);
            firstDay = formatDate(new Date(d1.getFullYear(), d1.getMonth(), 1));
            lastDay = formatDate(new Date(d1.getFullYear(), d1.getMonth() + 1, 0));
        }
        else if (range === "nextMonth") {

            d1 = new Date(moment().add(1, 'month'));
            //console.log('nextMonth',d1);
            firstDay = formatDate(new Date(d1.getFullYear(), d1.getMonth(), 1));
            lastDay = formatDate(new Date(d1.getFullYear(), d1.getMonth() + 1, 0));

        }

        else if (range.toLowerCase() === "weekly") {
            d1 = new Date(date);
            d2 = new Date(date);
            var first = d1.getDate() - d1.getDay(); // First day is the day of the month - the day of the week
            var last = first + 6; // last day is the first day + 6
            firstDay = new Date(d1.setDate(first)).toUTCString();
            lastDay = new Date(d2.setDate(last)).toUTCString();
            firstDay = formatDate(new Date(firstDay));
            lastDay = formatDate(new Date(lastDay));
        }
        if (grades == 0) {
            grade = grades;
        } else {
            grade = gradeNoToText(grades);
        }

        (grade == 0 ? (get('/reports/catererExportReport?isVersion2=true&mealSchoolId=' + sessionStorage.getItem('SchoolId') + '&startDate=' + firstDay + '&endDate=' + lastDay + '&fileType=' + fileType + '&access_token=')) : (get('/reports/catererExportReport?isVersion2=true&mealSchoolId=' + sessionStorage.getItem('SchoolId') + '&startDate=' + firstDay + '&endDate=' + lastDay + '&grades=' + grade + '&fileType=' + fileType + '&access_token='))).then((response) => {
            if (!response.ok) {
                if (response.status === 417) {
                    return response.json();
                }
            }
            console.log('response', response);
            return response;
        }).then(res => {
            if (res.statusCode === 417) {
                // _addNotificationError(res.statusMessage,this)
                throw Error(res.statusMessage);
            } else if (!res.statusCode === 200) {
                throw Error(res.errorMessage);
            } else {
                return res.blob();
            }
        }).then(blob => {
            let filename = 'Caterer' + ' ' + range + ' ' + (grades == 0 ? 'all grades' : 'grade-' + grades) + ' ' + 'reports';

            if (fileType === "Pdf") {
                //download(blob, filename + '.pdf', "pdf");
                showFile(blob, filename);
            }
            else {
                download(blob,
                    filename + '.xls', "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
            }
        }).catch(
            (error) => {
                let msg = ''
                if (typeof error === 'string') {
                    msg = error;
                } else {
                    msg = error.message;
                }
                _addNotificationError(msg, _self)
                this.setState({ loading: false })
                //console.log('Get Excel File response', error)
            }
        )
    }

    formatData = () => {
        let dataArray = [];
        let d1 = new Date(), d2 = new Date(), d3 = new Date(), d4 = new Date(), d5 = new Date(), d6 = new Date(), d7 = new Date(), d8 = new Date(), nextDay = '', dayAfter = '', cFirst = '', cLast = '', nFirst = '', nLast = '', wAFirst = '', wALast = '', next = d1.getDate() + 1, after = d2.getDate() + 2, currentDay = new Date(),
            cFDay = '', cLDay = '', nFDay = '', nLDay = '', wAFirstDay = '', wALastDay = '', currentWeek = '', nextWeek = '', weekAfter = '';


        nextDay = new Date(d1.setDate(next)).toUTCString();
        dayAfter = new Date(d2.setDate(after)).toUTCString();
        console.log('firstDay', nextDay);
        console.log('lastDay', dayAfter);
        nextDay = new Date(nextDay);
        dayAfter = new Date(dayAfter);

        currentDay = (currentDay.getMonth() + 1) + '/' + currentDay.getDate() + '/' + currentDay.getFullYear();
        nextDay = (nextDay.getMonth() + 1) + '/' + nextDay.getDate() + '/' + nextDay.getFullYear();
        dayAfter = (dayAfter.getMonth() + 1) + '/' + dayAfter.getDate() + '/' + dayAfter.getFullYear();

        // current week
        cFirst = d3.getDate() - d3.getDay(); // First day is the day of the month - the day of the week
        cLast = cFirst + 6; // last day is the first day + 6
        console.log('cFirst', cFirst);
        console.log('cLast', cLast);
        cFDay = new Date(d3.setDate(cFirst)).toUTCString();
        cLDay = new Date(d4.setDate(cLast)).toUTCString();
        console.log('firstDay', cFDay);
        console.log('lastDay', cLDay);
        cFDay = new Date(cFDay);
        cLDay = new Date(cLDay);
        // next week
        nFirst = d4.getDate() - d4.getDay() + 7; // First day is the day of the month - the day of the week
        nLast = nFirst + 6; // last day is the first day + 6
        console.log('cFirst', nFirst);
        console.log('cLast', nLast);
        nFDay = new Date(d5.setDate(nFirst)).toUTCString();
        nLDay = new Date(d6.setDate(nLast)).toUTCString();
        console.log('firstDay', nFDay);
        console.log('lastDay', nLDay);
        nFDay = new Date(nFDay);
        nLDay = new Date(nLDay);
        // week after

        wAFirst = d7.getDate() - d7.getDay() + 14; // First day is the day of the month - the day of the week
        wALast = wAFirst + 6; // last day is the first day + 6
        console.log('cFirst', wAFirst);
        console.log('cLast', wALast);
        wAFirstDay = new Date(d7.setDate(wAFirst)).toUTCString();
        wALastDay = new Date(d8.setDate(wALast)).toUTCString();
        console.log('firstDay', wAFirstDay);
        console.log('lastDay', wALastDay);
        wAFirstDay = new Date(wAFirstDay);
        wALastDay = new Date(wALastDay);

        currentWeek = (cFDay.getMonth() + 1) + '/' + cFDay.getDate() + ' - ' + (cLDay.getMonth() + 1) + '/' + cLDay.getDate();
        nextWeek = (nFDay.getMonth() + 2) + '/' + nFDay.getDate() + ' - ' + (nLDay.getMonth() + 2) + '/' + nLDay.getDate();
        weekAfter = (wAFirstDay.getMonth() + 1) + '/' + wAFirstDay.getDate() + ' - ' + (wALastDay.getMonth() + 1) + '/' + wALastDay.getDate();

        const cweek = (moment().startOf('week').format('M/D')) + ' - ' + (moment().endOf('week').format('M/D'));
        const nweek = (moment().add(1, 'week').startOf('week').format('M/D')) + ' - ' + (moment().add(1, 'week').endOf('week').format('M/D'));
        const nweekAfter = (moment().add(2, 'week').startOf('week').format('M/D')) + ' - ' + (moment().add(2, 'week').endOf('week').format('M/D'));
        // dataArray.push({
        //     report: 'Daily School Reports for All Grades (Print Labels- 2" x 2")',
        //     col1: <div>
        //         <p className="panel-body-QuickReports-Date">{currentDay}</p>
        //         <PrintLabels {...this} schoolYear={sessionStorage.getItem('schoolYearValue')} 
        //         selectedDate={moment().format('YYYY-MM-DD')} showErrorMessage={(message)=>{
        //             _addNotificationError(message,this);
        //         }}
        //         schoolId={sessionStorage.getItem('SchoolId')} /></div>,
        //     col2: <div>

        //     </div>,
        //     col3: <div>

        //     </div>,

        // });
        dataArray.push({
            report: 'Daily School Reports for All Grades',
            col1: <div>
                <p className="panel-body-QuickReports-Date">{currentDay}</p>
                <a title="Click to Download PDF"
                    onClick={() => { this.quickReports('Pdf', 'currentDay') }}

                    target='_blank'
                    className="fa fa-file-pdf-o fa-2x QuickReports-PDF"><i /></a>
                <a title="Click to Download Excel"
                    onClick={() => this.quickReports('Excel', 'currentDay')}
                    target='_blank'

                    className="fa fa-file-excel-o fa-2x QuickReports-Excel"><i /></a>
            </div>,
            col2: <div>
                <p className="panel-body-QuickReports-Date">{nextDay}</p>
                <a title="Click to Download PDF"
                    onClick={() => this.quickReports('Pdf', 'nextDay')}

                    target='_blank'
                    className="fa fa-file-pdf-o fa-2x QuickReports-PDF"><i /></a>

                <a title="Click to Download Excel"
                    onClick={() => this.quickReports('Excel', 'nextDay')}
                    target='_blank'

                    className="fa fa-file-excel-o fa-2x QuickReports-Excel"><i /></a>
            </div>,
            col3: <div>
                <p className="panel-body-QuickReports-Date">{dayAfter}</p>
                <a title="Click to Download PDF"
                    onClick={() => this.quickReports('Pdf', 'dayAfter')}

                    target='_blank'
                    className="fa fa-file-pdf-o fa-2x QuickReports-PDF"><i /></a>

                <a title="Click to Download Excel"
                    onClick={() => this.quickReports('Excel', 'dayAfter')}
                    target='_blank'

                    className="fa fa-file-excel-o fa-2x QuickReports-Excel"><i /></a>
            </div>,

        })
        dataArray.push({
            report: 'Weekly School Reports for All Grades',
            col1: <div>
                <p className="panel-body-QuickReports-Date">{cweek}</p>
                <a title="Click to Download PDF"
                    onClick={() => this.exportSchoolReport('Pdf', 'Weekly', new Date(), 0)}
                    target='_blank'

                    className="fa fa-file-pdf-o fa-2x QuickReports-PDF"><i /></a>

                <a title="Click to Download Excel"
                    onClick={() => this.exportSchoolReport('Excel', 'Weekly', new Date(), 0)}
                    target='_blank'

                    className="fa fa-file-excel-o fa-2x QuickReports-Excel"><i /></a>
            </div>,
            col2: <div>
                <p className="panel-body-QuickReports-Date">{nweek}</p>
                <a title="Click to Download PDF"
                    onClick={() => this.exportSchoolReport('Pdf', 'nextWeek', new Date(), 0)}
                    target='_blank'

                    className="fa fa-file-pdf-o fa-2x QuickReports-PDF"><i /></a>

                <a title="Click to Download Excel"
                    onClick={() => this.exportSchoolReport('Excel', 'nextWeek', new Date(), 0)}
                    target='_blank'

                    className="fa fa-file-excel-o fa-2x QuickReports-Excel"><i /></a>
            </div>,
            col3: <div>
                <p className="panel-body-QuickReports-Date">{nweekAfter}</p>
                <a title="Click to Download PDF"
                    onClick={() => this.exportSchoolReport('Pdf', 'weekAfter', new Date(), 0)}
                    target='_blank'

                    className="fa fa-file-pdf-o fa-2x QuickReports-PDF"><i /></a>

                <a title="Click to Download Excel"
                    onClick={() => this.exportSchoolReport('Excel', 'weekAfter', new Date(), 0)}
                    target='_blank'

                    className="fa fa-file-excel-o fa-2x QuickReports-Excel"><i /></a>
            </div>
        });
        dataArray.push({
            report: 'Monthly Caterer Reports for All Grades',
            col1: <div>
                <p className="panel-body-QuickReports-Date">{(new Date().getMonth() + 1) + '/' + new Date().getFullYear()}</p>
                <a title="Click to Download PDF"
                    onClick={() => this.exportCatererReport('Pdf', 'Monthly', new Date(), 0)}
                    target='_blank'

                    className="fa fa-file-pdf-o fa-2x QuickReports-PDF"><i /></a>

                <a title="Click to Download Excel"
                    onClick={() => this.exportCatererReport('Excel', 'Monthly', new Date(), 0)}
                    target='_blank'
                    className="fa fa-file-excel-o fa-2x QuickReports-Excel"><i /></a>
            </div>,
            col2: <div>
                <p className="panel-body-QuickReports-Date">{new Date(moment().add(1, 'month')).getMonth() + 1 + '/' + new Date(moment().add(1, 'month')).getFullYear()}</p>
                <a title="Click to Download PDF"
                    onClick={() => this.exportCatererReport('Pdf', 'nextMonth', new Date(), 0)}
                    target='_blank'

                    className="fa fa-file-pdf-o fa-2x QuickReports-PDF"><i /></a>

                <a title="Click to Download Excel"
                    onClick={() => this.exportCatererReport('Excel', 'nextMonth', new Date(), 0)}
                    target='_blank'

                    className="fa fa-file-excel-o fa-2x QuickReports-Excel"><i /></a>
            </div>
        });
        if (getAccessLevelByModule(modEnum.MKA)) {
            dataArray.push({
                report: 'Allergy Reports for All Grades',
                col1: <div>
                    <p className="panel-body-QuickReports-Date"></p>
                    <a title="Click to Download PDF"
                        onClick={() => this.exportAllergyReport('Pdf')}
                        target='_blank'

                        className="fa fa-file-pdf-o fa-2x QuickReports-PDF"><i /></a>

                    <a title="Click to Download Excel"
                        onClick={() => this.exportAllergyReport('Excel')}
                        target='_blank'
                        className="fa fa-file-excel-o fa-2x QuickReports-Excel"><i /></a>
                </div>,
                col2: <div>

                </div>
            });
        }
        if (getAccessLevelByModule(modEnum.OLEA)) {
            dataArray.push({
                report: 'Free/Reduced Price Lunch Eligibility Survey Report',
                col1: <div>
                    <p className="panel-body-QuickReports-Date"></p>
                    <a title="Click to Download PDF"
                        onClick={() => this.exportFreeReducedLunchReport('Pdf')}
                        target='_blank'

                        className="fa fa-file-pdf-o fa-2x QuickReports-PDF"><i /></a>

                    <a title="Click to Download Excel"
                        onClick={() => this.exportFreeReducedLunchReport('Excel')}
                        target='_blank'
                        className="fa fa-file-excel-o fa-2x QuickReports-Excel"><i /></a>
                </div>,
                col2: <div>

                </div>
            });
        }
        dataArray.push({
            report: 'Regularly ordered lunch students but not having order in specific month',
            col1: <div>
                <p className="panel-body-QuickReports-Date">{(new Date().getMonth() + 1) + '/' + new Date().getFullYear()}</p>

                <a title="Click to Download PDF"
                    onClick={() => this.notOrderedLunchReport('Pdf', 'thisMonth', new Date(), 0)}
                    target='_blank'

                    className="fa fa-file-pdf-o fa-2x QuickReports-PDF"><i /></a>

                <a title="Click to Download Excel"
                    onClick={() => this.notOrderedLunchReport('Excel', 'thisMonth', new Date(), 0)}
                    target='_blank'
                    className="fa fa-file-excel-o fa-2x QuickReports-Excel"><i /></a>
            </div>,
            col2: <div>
                <p className="panel-body-QuickReports-Date">{new Date(moment().add(1, 'month')).getMonth() + 1 + '/' + new Date(moment().add(1, 'month')).getFullYear()}</p>
                <a title="Click to Download PDF"
                    onClick={() => this.notOrderedLunchReport('Pdf', 'nextMonth', new Date(), 0)}
                    target='_blank'

                    className="fa fa-file-pdf-o fa-2x QuickReports-PDF"><i /></a>

                <a title="Click to Download Excel"
                    onClick={() => this.notOrderedLunchReport('Excel', 'nextMonth', new Date(), 0)}
                    target='_blank'
                    className="fa fa-file-excel-o fa-2x QuickReports-Excel"><i /></a>

            </div>
        });
        if (getAccessLevelByModule(modEnum.OLEA)) {
            dataArray.push({
                report: 'Students Lunch Eligibility Program Actual Report',
                col1: <div>
                    <p className="panel-body-QuickReports-Date">Free/Reduced</p>
                    <a title="Click to Download PDF"
                        onClick={() => this.exportFreeReducedLunchActualReport('Pdf')}
                        target='_blank'
                        className="fa fa-file-pdf-o fa-2x QuickReports-PDF"><i /></a>
                    <a title="Click to Download Excel"
                        onClick={() => this.exportFreeReducedLunchActualReport('Excel')}
                        target='_blank'
                        className="fa fa-file-excel-o fa-2x QuickReports-Excel"><i /></a>
                </div>,
                col2: <div>
                    <p className="panel-body-QuickReports-Date">Free</p>
                    <a title="Click to Download PDF"
                        onClick={() => this.exportFreeReducedLunchActualReport('Pdf', 'Free')}
                        target='_blank'
                        className="fa fa-file-pdf-o fa-2x QuickReports-PDF"><i /></a>
                    <a title="Click to Download Excel"
                        onClick={() => this.exportFreeReducedLunchActualReport('Excel', 'Free')}
                        target='_blank'
                        className="fa fa-file-excel-o fa-2x QuickReports-Excel"><i /></a>
                </div>,
                col3: <div>
                    <p className="panel-body-QuickReports-Date">Reduced</p>
                    <a title="Click to Download PDF"
                        onClick={() => this.exportFreeReducedLunchActualReport('Pdf', 'Reduced')}
                        target='_blank'
                        className="fa fa-file-pdf-o fa-2x QuickReports-PDF"><i /></a>
                    <a title="Click to Download Excel"
                        onClick={() => this.exportFreeReducedLunchActualReport('Excel', 'Reduced')}
                        target='_blank'
                        className="fa fa-file-excel-o fa-2x QuickReports-Excel"><i /></a>
                </div>,
                col4: <div>
                    <p className="panel-body-QuickReports-Date">Regular</p>
                    <a title="Click to Download PDF"
                        onClick={() => this.exportFreeReducedLunchActualReport('Pdf', 'Regular')}
                        target='_blank'
                        className="fa fa-file-pdf-o fa-2x QuickReports-PDF"><i /></a>
                    <a title="Click to Download Excel"
                        onClick={() => this.exportFreeReducedLunchActualReport('Excel', 'Regular')}
                        target='_blank'
                        className="fa fa-file-excel-o fa-2x QuickReports-Excel"><i /></a>
                </div>
            });
        }
        return dataArray;
    }
    getLunchEligibilityReports = () => {
        this.setState({ loading: true });
        const eligTypeParam = this.state.eligTypes.length > 0
            ? '&' + this.state.eligTypes.map(t => `eligType=${encodeURIComponent(t)}`).join('&')
            : '';
        get(`/reports/fmActualReport?mealSchoolId=${sessionStorage.getItem('SchoolId')}&fileType=AllData&schoolYear=${sessionStorage.getItem('schoolYearValue')}${eligTypeParam}&access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            this.setState({ lunchEligibilityReportResponse: data.response, loading: false })
        }).catch(error => {
            this.setState({ loading: false });
            console.log("Loading Report Failed", error)
        })
    };
    handleEligTypeChange = (type) => {
        const current = this.state.eligTypes;
        let updated;
        if (current.includes(type)) {
            updated = current.filter(t => t !== type);
        } else if (type === 'Regular') {
            updated = ['Regular'];
        } else {
            updated = [...current.filter(t => t !== 'Regular'), type];
        }
        this.setState({ eligTypes: updated }, () => {
            this.getLunchEligibilityReports();
        });
    };
    getLunchEligibilityReportsPdf = () => {
        this.setState({ loading: true });
        const eligTypeParam = this.state.eligTypes.length > 0
            ? '&' + this.state.eligTypes.map(t => `eligType=${encodeURIComponent(t)}`).join('&')
            : '';
        get(`/reports/fmActualReport?mealSchoolId=${sessionStorage.getItem('SchoolId')}&fileType=Pdf&schoolYear=${sessionStorage.getItem('schoolYearValue')}${eligTypeParam}&access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            this.setState({ loading: false });
            return response.blob();
        }).then(blob => {
            const eligLabel = this.state.eligTypes.length === 0
                ? 'All'
                : this.state.eligTypes.length === 1
                    ? this.state.eligTypes[0]
                    : 'Multiple Types';
            let filename = `Lunch Eligibility Reports - ${eligLabel}`;
            showFile(blob, filename);
        }).catch(error => {
            this.setState({ loading: false });
            console.log("Download Failed", error)
        })
    };
    buildLunchEligibilityFormatForExport = () => {
        const gradeGroup = groupBy(getSchoolGrades(0, false), 'value');
        let fData = [];
        let result = [];
        this.state.lunchEligibilityReportResponse.map(row => {
            fData.push([
                row.studentId,
                row.studentFName,
                row.studentLName,
                `${((gradeGroup[row.gradeName] || [])[0] || {}).label || ''}`,
                row.teacherName,
                `${(row.freeMeal || '') === true ? 'FreeMeals' : (row.reducedPrice || '') === true ? 'ReducedPrice' : 'RegularPrice'}`,
                row.reCertificateDate]);

        });
        result.push(
            {
                columns: ['', ''],
                data: [['Title:', 'Lunch Eligibility Report'], ['', '']]
            }
        )
        result.push(
            {
                columns: [
                    'StudentId',
                    'Student First Name',
                    'Student Last Name',
                    'Grade',
                    'Teacher',
                    "Eligibility",
                    "Re-Certification Date",
                ],
                data: fData
            }
        );
        return result;
    }
    render() {
        const { schoolYearSettings } = this.state;
        const { adverseActionProcedure, schoolYear } = schoolYearSettings || {};
        const gradeGroup = groupBy(getSchoolGrades(0, false), 'value');
        let settings = {
            dots: false,
            arrows: true,
            infinite: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            lazyLoad: true

        };

        const quickReportsDataList = this.formatData();

        return (
            <div className="row">
                <NotificationSystem ref="notificationSystem" />
                <section className="whiteSection full-width clearfix p-t-n">
                    <div className="container">
                        <div className='sweet-loading'
                            style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000' }}>
                            <BeatLoader
                                size={20}
                                color={'#ea7066'}
                                loading={this.state.loading}
                            />
                        </div>
                        <div className="row">
                            <div className="col-xs-12">
                                <div className="sectionTitle">
                                    <h2>
                                        <span>Claim Reports </span>
                                    </h2>
                                </div>
                            </div>
                        </div>
                        {
                            (getAccessLevelByModule(modEnum.FNSAR) && getAccessLevelByModule(modEnum.CEPS)) ?
                                <div className="panel panel-p1 panel-primary">
                                    <div className="panel-heading text-center">
                                        <h3 className="panel-title">CEP Reimbursement claim report</h3>
                                    </div>
                                    <div className="panel-body panel-body-QuickReports">
                                        <CepAuditReport />
                                    </div>
                                </div>

                                :



                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="tabCommon custom-tabCommon">
                                            <ul className="nav nav-tabs" role="tablist">
                                                <li role="presentation" className="active" onClick={() => {
                                                    this.getLunchEligibilityReports()
                                                }}>
                                                    <a href="#Section6" aria-controls="messages" role="tab"
                                                        data-toggle="tab">Lunch Eligibility Report </a></li>
                                                {
                                                    getAccessLevelByModule(modEnum.FNSAR) && !getAccessLevelByModule(modEnum.CEPS) ?
                                                        <li role="presentation">
                                                            <a href="#Section4" aria-controls="messages" role="tab"
                                                                data-toggle="tab">Reimbursement Claim Report</a></li> : null
                                                }

                                                {<li role="presentation">
                                                    <a href="#Section_TER" aria-controls="messages" role="tab" data-toggle="tab">Temp Eligibility Report</a></li>
                                                }
                                                {<li role="presentation">
                                                    <a href="#Section_FRL" aria-controls="messages" role="tab" data-toggle="tab">FRL Report</a></li>
                                                }
                                                { getAccessLevelByModule(modEnum.LETM) ? 
                                                   <li role="presentation">
                                                        <a href="#Section_BFL" aria-controls="messages" role="tab"
                                                            data-toggle="tab">Benefits issuance Report</a></li> 
                                                 : null}
                                               
                                                { adverseActionProcedure ? (
                                                    <li role="presentation" style={{marginTop:'2%'}}>
                                                        <a href="#Section_ADA" aria-controls="messages" role="tab"
                                                            data-toggle="tab">Adverse Action Report</a>
                                                    </li>
                                                ) : null }
                                            </ul>

                                            <div className="tab-content">
                                                <div role="tabpanel" className="tab-pane" id="Section4">
                                                    <div className="panel panel-p1 panel-primary">
                                                        <div className="panel-heading text-center">
                                                            <h3 className="panel-title">Reimbursement claim report</h3>
                                                        </div>
                                                        <div className="panel-body panel-body-QuickReports">
                                                            <AuditReport />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div role="tabpanel" className="tab-pane" id="Section5">
                                                    <div className="panel panel-primary ">
                                                        <div className="panel-heading text-center">
                                                            <h3 className="panel-title">Daily Edit Check Report</h3>
                                                        </div>
                                                        <div className="panel-body panel-body-QuickReports">
                                                            <div className="row">
                                                                <div className="col-md-offset-3 col-md-6">
                                                                    <div className="panel panel-primary">
                                                                        <div className="panel-body">
                                                                            <div className="row">
                                                                                <div className="uploadFileInfo col-md-12 createmenu-month-group form-group">
                                                                                    <label className="custom-label col-md-4 text-left" style={{ margin: '18px 0px' }}>Report for</label>
                                                                                    <div className="input-group col-md-8 col-sm-12 col-xs-12">
                                                                                        <div className="row">
                                                                                            <div className="styled-input-single col-md-4">
                                                                                                <input type="radio" name="mealTypes" id={'rbs' + enumMealType.lunch} onChange={() => {
                                                                                                    this.setState({ mealTypes: enumMealType.lunch })
                                                                                                    console.log("lunch11111----", enumMealType.lunch)
                                                                                                }} checked={this.state.mealTypes === enumMealType.lunch} />
                                                                                                <label htmlFor={'rbs' + enumMealType.lunch}>{enumMealType.lunch}</label>
                                                                                            </div>
                                                                                            <div className="styled-input-single col-md-5">
                                                                                                <input type="radio" name="mealTypes" id={'rbs' + enumMealType.breakfast} onChange={() => {
                                                                                                    this.setState({ mealTypes: enumMealType.breakfast })
                                                                                                    console.log("breakfast1111111----", enumMealType.breakfast)
                                                                                                }} checked={this.state.mealTypes === enumMealType.breakfast} />
                                                                                                <label htmlFor={'rbs' + enumMealType.breakfast}>{enumMealType.breakfast}</label>
                                                                                            </div>
                                                                                            <div className="styled-input-single col-md-3">
                                                                                                <input type="radio" name="mealTypes" id={'rbs' + enumMealType.milk} onChange={() => {
                                                                                                    this.setState({ mealTypes: enumMealType.milk })
                                                                                                    console.log("milk111111----", enumMealType.milk)
                                                                                                }} checked={this.state.mealTypes === enumMealType.milk} />
                                                                                                <label htmlFor={'rbs' + enumMealType.milk}>{enumMealType.milk}</label>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="uploadFileInfo createmenu-month-group form-group">
                                                                                        <label className="custom-label col-md-4 text-left" style={{ margin: '10px 0px' }}>Month</label>
                                                                                        <div className="input-group col-md-8 col-sm-12 col-xs-12">
                                                                                            <Datetime inputProps={{ placeholder: 'Select Month' }}
                                                                                                ref='calendar' dateFormat="MMMM YYYY"
                                                                                                timeFormat={false}
                                                                                                value={this.state.checkReportDate}
                                                                                                closeOnSelect={true} isValidDate={valid}
                                                                                                onChange={this.setCheckReportDate}
                                                                                                renderInput={this.renderInput}
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    <button className="btn btn-success btn-sm pull-right" onClick={(e) => {
                                                                        e.preventDefault();
                                                                        this.downloadReport();
                                                                    }}> Download Report
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div role="tabpanel" className="tab-pane active" id="Section6">
                                                    <div className="panel panel-primary ">
                                                        <div className="panel-heading text-center">
                                                            <h3 className="panel-title" style={{ display: 'inline' }}>Lunch Eligibility Report</h3>
                                                            <div style={{
                                                                display: 'inline-block',
                                                                backgroundColor: 'transparent',
                                                                marginTop: '-7px',
                                                                float: 'right',
                                                                borderRadius: '3px'
                                                            }}>
                                                                <div className="btn-group">
                                                                    <button className="btn-link btn-sm dropdown-toggle" type="button"
                                                                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{ color: '#fff', fontSize: '13px' }}>
                                                                        <i className="fa fa-file" aria-hidden="true"></i> Export <span className="caret"></span>
                                                                    </button>
                                                                    <ul className="dropdown-menu">
                                                                        <li>
                                                                            <a title="Click to Download PDF" style={{ cursor: 'pointer' }}
                                                                                onClick={() => {
                                                                                    this.getLunchEligibilityReportsPdf()
                                                                                }}
                                                                                target='_blank'
                                                                            ><i className="fa fa-file-pdf-o" /> Pdf</a>
                                                                        </li>
                                                                        <li>
                                                                            <TmExportExcel id="lunchEligibilityRpt"
                                                                                name={"Lunch Eligibility Report"}
                                                                                filename={"Lunch Eligibility Report"}
                                                                                element={<a title="Click to Download Excel" id="lunchEligibilityRpt"
                                                                                    style={{
                                                                                        display: 'block',
                                                                                        padding: '3px 20px',
                                                                                        clear: 'both',
                                                                                        fontWeight: '400',
                                                                                        lineHeight: 1.42857143,
                                                                                        color: '#333',
                                                                                        whiteSpace: 'nowrap',
                                                                                        cursor: 'pointer'
                                                                                    }}
                                                                                ><i className="fa fa-file-excel-o" /> Excel</a>}
                                                                                dataSet={this.buildLunchEligibilityFormatForExport()}
                                                                            />
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="panel-body panel-body-QuickReports">


                                                            <div className="row">

                                                                <div className="col-sm-6 col-xs-6">
                                                                    <label style={{ marginLeft: '20px' }}>Lunch Eligibility Report</label>
                                                                </div>
                                                                <div className="col-sm-6 col-xs-6">
                                                                    <div style={{ display: 'inline-flex', alignItems: 'center' }}><label style={{ margin: '5px', fontWeight: 'bold' }}> Type: </label>
                                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                            {['Free', 'Reduced', 'Regular'].map(type => {
                                                                                const { eligTypes } = this.state;
                                                                                const hasRegular = eligTypes.includes('Regular');
                                                                                const hasFreeOrReduced = eligTypes.includes('Free') || eligTypes.includes('Reduced');
                                                                                const isDisabled = (type === 'Regular' && hasFreeOrReduced) || (type !== 'Regular' && hasRegular);
                                                                                return (
                                                                                    <div key={type} className="styled-input-single" style={{ padding: '0 0 0 30px', marginRight: '16px', opacity: isDisabled ? 0.4 : 1 }}>
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            id={'eligType' + type}
                                                                                            value={type}
                                                                                            checked={eligTypes.includes(type)}
                                                                                            onChange={() => this.handleEligTypeChange(type)}
                                                                                            disabled={isDisabled}
                                                                                        />
                                                                                        <label htmlFor={'eligType' + type} style={{ cursor: isDisabled ? 'not-allowed' : 'pointer' }}>{type}</label>
                                                                                    </div>
                                                                                );
                                                                            })}
                                                                        </div>
                                                                    </div>

                                                                </div>

                                                            </div>
                                                            <div className="row"><ReactTable style={{ textAlign: 'center' }}
                                                                data={this.state.lunchEligibilityReportResponse}
                                                                columns={[{ Header: "StudentId", style: { width: '100%' }, accessor: "studentId" },
                                                                {
                                                                    Header: "Student First Name",
                                                                    Cell: props => <span>{props.original.studentFName || ''}</span>
                                                                },
                                                                {
                                                                    Header: "Student Last Name",
                                                                    Cell: props => <span>{props.original.studentLName || ''}</span>
                                                                },
                                                                {
                                                                    Header: "Grade", style: { textAlign: 'center', textTransform: 'capitalize' }, Cell: (props) => {
                                                                        return <span>{
                                                                            ((gradeGroup[props.original.gradeName] || [])[0] || {}).label || ''}</span>
                                                                    }
                                                                },
                                                                { Header: "Teacher", accessor: "teacherName" },
                                                                { Header: "Eligibility", Cell: props => <span>{(props.original.freeMeal) === true ? 'FreeMeals' : (props.original.reducedPrice) === true ? 'ReducedPrice' : 'RegularPrice'}</span> },
                                                                { Header: "Re-Certification Date", accessor: "reCertificateDate" }]}
                                                                defaultPageSize={10}
                                                                className="-striped -highlight"
                                                                noDataText='No data found'
                                                            /></div>

                                                        </div>


                                                    </div>
                                                </div>
                                                <div role="tabpanel" className="tab-pane" id="Section_TER">
                                                    <div className="panel panel-p1 panel-primary">
                                                        <div className="panel-heading text-center">
                                                            <h3 className="panel-title" style={{ display: 'inline' }}>Temp Eligibility Report</h3>
                                                            <div style={{
                                                                display: 'inline-block',
                                                                backgroundColor: 'transparent',
                                                                marginTop: '-7px',
                                                                float: 'right',
                                                                borderRadius: '3px'
                                                            }}>
                                                                <div className="btn-group">
                                                                    <button className="btn-link btn-sm dropdown-toggle" type="button"
                                                                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{ color: '#fff', fontSize: '13px' }}>
                                                                        <i className="fa fa-file" aria-hidden="true"></i> Export <span className="caret"></span>
                                                                    </button>
                                                                    <ul className="dropdown-menu">
                                                                        <li>
                                                                            <a title="Click to Download PDF" style={{ cursor: 'pointer' }}
                                                                                onClick={(e) => {
                                                                                    this.refs.tempEligibilityRept.downloadPdf(e);
                                                                                }}
                                                                                target='_blank'
                                                                            ><i className="fa fa-file-pdf-o" /> Pdf</a>
                                                                        </li>
                                                                        <li>
                                                                            <a title="Click to Download Excel" href="javascript:void(0)"
                                                                                style={{
                                                                                    display: 'block',
                                                                                    padding: '3px 20px',
                                                                                    clear: 'both',
                                                                                    fontWeight: '400',
                                                                                    lineHeight: 1.42857143,
                                                                                    color: '#333',
                                                                                    whiteSpace: 'nowrap',
                                                                                    cursor: 'pointer'
                                                                                }} onClick={(e) => {
                                                                                    this.refs.tempEligibilityRept.btnExportExcelOnClick(e)

                                                                                }}
                                                                            ><i className="fa fa-file-excel-o" /> Excel</a>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="panel-body panel-body-QuickReports">
                                                            <TempEligibilityReport ref='tempEligibilityRept'{...this} showHideLoading={(loading) => {
                                                                this.setState({ loading })
                                                            }} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div role="tabpanel" className="tab-pane" id="Section_FRL">
                                                    <div className="panel panel-p1 panel-primary">
                                                        <div className="panel-heading text-center">
                                                            <h3 className="panel-title" style={{ display: 'inline' }}>FRL Report</h3>
                                                            <div style={{
                                                                display: 'inline-block',
                                                                backgroundColor: 'transparent',
                                                                marginTop: '-7px',
                                                                float: 'right',
                                                                borderRadius: '3px'
                                                            }}>
                                                                <div className="btn-group">
                                                                    <button className="btn-link btn-sm dropdown-toggle" type="button"
                                                                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{ color: '#fff', fontSize: '13px' }}>
                                                                        <i className="fa fa-file" aria-hidden="true"></i> Export <span className="caret"></span>
                                                                    </button>
                                                                    <ul className="dropdown-menu">
                                                                        <li>
                                                                            <a title="Click to Download PDF" style={{ cursor: 'pointer' }}
                                                                                onClick={(e) => {
                                                                                    this.refs.frlRept.getFRLReportsPdf(this.state.mealTypes, "pdf");
                                                                                }}
                                                                                target='_blank'
                                                                            ><i className="fa fa-file-pdf-o" /> Pdf</a>
                                                                        </li>
                                                                        <li>
                                                                            <a title="Click to Download Excel" href="javascript:void(0)"
                                                                                style={{
                                                                                    display: 'block',
                                                                                    padding: '3px 20px',
                                                                                    clear: 'both',
                                                                                    fontWeight: '400',
                                                                                    lineHeight: 1.42857143,
                                                                                    color: '#333',
                                                                                    whiteSpace: 'nowrap',
                                                                                    cursor: 'pointer'
                                                                                }} onClick={(e) => {
                                                                                    this.refs.frlRept.getFRLReportsPdf(this.state.mealTypes, "excel")

                                                                                }}
                                                                            ><i className="fa fa-file-excel-o" /> Excel</a>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="panel-body panel-body-QuickReports">
                                                            <FRLReport ref='frlRept'{...this} showHideLoading={(loading) => {
                                                                this.setState({ loading })
                                                            }} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div role="tabpanel" className="tab-pane" id="Section_BFL">
                                                    <div className="panel panel-p1 panel-primary">
                                                        <div className="panel-heading text-center">
                                                            <h3 className="panel-title" style={{ display: 'inline' }}>Benefits Issuance List Report</h3>
                                                            <div style={{
                                                                display: 'inline-block',
                                                                backgroundColor: 'transparent',
                                                                marginTop: '-7px',
                                                                float: 'right',
                                                                borderRadius: '3px'
                                                            }}>
                                                                <div className="btn-group">
                                                                    <button className="btn-link btn-sm dropdown-toggle" type="button"
                                                                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{ color: '#fff', fontSize: '13px' }}>
                                                                        <i className="fa fa-file" aria-hidden="true"></i> Export <span className="caret"></span>
                                                                    </button>
                                                                    <ul className="dropdown-menu">
                                                                        <li>
                                                                            <a title="Click to Download PDF" style={{ cursor: 'pointer' }}
                                                                              onClick={() => {
                                                                                        const comp = this.refs.benefitsIssuanceListRept;
                                                                                        comp.getData(comp.state.dateFilter, true);
                                                                                        }}
                                                                                target='_blank'
                                                                            ><i className="fa fa-file-pdf-o" /> Pdf</a>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="panel-body panel-body-QuickReports">
                                                            <BenefitsIssuanceListReport ref='benefitsIssuanceListRept'{...this} showHideLoading={(loading) => {
                                                                this.setState({ loading })
                                                            }} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div role="tabpanel" className="tab-pane" id="Section_ADA">
                                                    <div className="panel panel-p1 panel-primary">
                                                        <div className="panel-heading text-center">
                                                            <h3 className="panel-title" style={{ display: 'inline' }}>Adverse Action Report</h3>
                                                             <div style={{
                                                                display: 'inline-block',
                                                                backgroundColor: 'transparent',
                                                                marginTop: '-7px',
                                                                float: 'right',
                                                                borderRadius: '3px'
                                                            }}>
                                                                </div>
                                                        </div>
                                                         <div className="panel-body panel-body-QuickReports">
                                                            <AdverseActionReport ref='adverseActionReport'{...this} 
                                                                                 schoolYear={schoolYear}
                                                                                 showHideLoading={(loading) => {
                                                                                                 this.setState({ loading })
                                                                               }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                        }
                    </div>
                </section>
            </div>
        );

    }
}

export default ClaimReport;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Reports/CliamReport/index.jsx